const IDLE_TIMEOUT_MS = 4000;
const FALLBACK_DELAY_MS = 2000;
export function scheduleIdleTask(callback) {
    let cancelIdle;
    const schedule = () => {
        if (typeof window.requestIdleCallback === 'function') {
            const idleId = window.requestIdleCallback(callback, { timeout: IDLE_TIMEOUT_MS });
            cancelIdle = () => window.cancelIdleCallback(idleId);
        }
        else {
            const timeoutId = globalThis.setTimeout(callback, FALLBACK_DELAY_MS);
            cancelIdle = () => globalThis.clearTimeout(timeoutId);
        }
    };
    if (document.readyState === 'complete')
        schedule();
    else
        window.addEventListener('load', schedule, { once: true });
    return () => {
        window.removeEventListener('load', schedule);
        cancelIdle?.();
    };
}
//# sourceMappingURL=schedule-idle-task.js.map